import React, { createContext, useState, useContext } from 'react';

export const WarningsContext = createContext();

export const WarningsProvider = ({ children }) => {
  const [showWarnings, setShowWarnings] = useState(true);

  return (
    <WarningsContext.Provider value={{ showWarnings, setShowWarnings }}>
      {children}
    </WarningsContext.Provider>
  );
};

export const useWarnings = () => {
  const context = useContext(WarningsContext);
  if (!context) {
    throw new Error('useWarnings must be used within a WarningsProvider');
  }
  return context;
}; 